export default __webpack_public_path__ + "static/media/1.5316a571.png";